import JoyField from '../types/JoyField';
import JoyDataService from '../services/JoyDataService';
import { isString, isDate } from '../validation/TypeChecking';
export default class JoyObject {
    constructor({ id, objectId, createdAt, createdBy = '' }) {
        this.observers = [];
        this.initialUpdate = []; // TODO: check if initialUpdate should be initialized in constructor
        this.listener = null;
        this.objectType = undefined; // TODO: decide if this property should come from child classes
        if (isString(id)) {
            this.id = id;
        }
        else if (isString(objectId)) {
            this.id = objectId;
        }
        if (!!this.id === false) {
            throw Error('Invalid field id.');
        }
        if (!isDate(createdAt)) {
            throw Error('Invalid field createdAt.');
        }
        this.createdAt = createdAt;
        if (isString(createdBy)) {
            this.createdBy = createdBy;
        }
    }
    // Observable
    addObserver(observer) {
        if (this.observers.indexOf(observer) < 0) {
            this.observers.push(observer);
            if (this.observers.length === 1) {
                this.listener.activate();
            }
            else {
                observer.notify(this.initialUpdate);
            }
        }
    }
    removeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index >= 0) {
            this.observers.splice(index, 1);
            if (this.observers.length === 0) {
                this.listener.deactivate();
            }
        }
    }
    notifyObservers(updates) {
        for (const observer of this.observers) {
            observer.notify(updates);
        }
    }
    // Helpers
    async updateData(data) {
        data[JoyField.objectType] = this.objectType;
        data[JoyField.id] = this.id;
        await JoyDataService.instance.update(data);
        return;
    }
}
JoyObject.fields = [];
//# sourceMappingURL=JoyObject.js.map